import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserDetails } from '../../model/userdetails';
import { RedeCredenciadaService } from '../../service/rede-credenciada/rede-credenciada.service';
import { Bairro, Cidade, Estado, RedeCredenciada } from '../../model/rede-credenciada';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-rede-crendeciada',
  templateUrl: './rede-credenciada.component.html',
  styleUrls: ['./rede-credenciada.component.css'],
  encapsulation: ViewEncapsulation.None
  //providers: [RelatorioService]
})

export class RedeCredenciadaComponent implements OnInit {
  estados: Bairro[] = [];
  cidades: Cidade[] = [];
  bairros: Bairro[] = [];

  estadoSelecionado: number;
  cidadeSelecionado: number;
  bairroSelecionado: string;

  // Filtro de produto: só aparece para planos que o backend indicar (hoje, Roche).
  exibeProduto = false;
  // 'TODOS' tem id próprio para o ng-select mostrar a opção escolhida; null é "nada selecionado".
  produtos = [
    { id: 'TODOS', name: 'Todos' },
    { id: 'BGM', name: 'BGM' },
    { id: 'CGM', name: 'CGM' }
  ];
  produtoSelecionado: string = null;

  redeCredenciadaArray: RedeCredenciada[] = [];

  user: UserDetails

  planoUsuario: number;

  dropdownSettings = {
    singleSelection: true,
    enableCheckAll: false,
    idField: 'value',
    textField: 'label',
    itemsShowLimit: 1,
    allowSearchFilter: false
  }

  constructor(
    private redeCredenciadaService: RedeCredenciadaService,
    private route: ActivatedRoute
  ) { }

  public ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('idUser'));
    this.carregarEstados();
    this.route.queryParams.subscribe(queryParams => {
      const idPlano = queryParams['id'];

      try {
        this.planoUsuario = Number(idPlano);
      } catch { }

      this.carregarExibeProduto();
    })
  }

  /**
   * Plano da busca. O id da URL, quando informado, vence o plano do usuário salvo no navegador:
   * a rota sem login precisa mostrar o plano pedido mesmo com um login anterior no localStorage.
   */
  get planoPesquisa(): number {
    if (this.planoUsuario) {
      return this.planoUsuario;
    }
    return this.user && this.user.is_Pln ? this.user.is_Pln : null;
  }

  async carregarEstados() {
    this.redeCredenciadaService.OnObterEstado().subscribe((response: Estado[]) => {
      this.estados = response;
    });
  }

  carregarExibeProduto() {
    if (!this.planoPesquisa) {
      return;
    }
    this.redeCredenciadaService.OnExibeProduto(this.planoPesquisa).subscribe((response: boolean) => {
      this.exibeProduto = response === true;
    });
  }

  changeEstado() {
    this.cidadeSelecionado = null;
    this.bairroSelecionado = null;
    this.redeCredenciadaService.OnObterCidades(this.estadoSelecionado).subscribe((response: Cidade[]) => {
      this.cidades = response;
    });
  }

  changeCidade() {
    this.bairroSelecionado = null;

    this.redeCredenciadaService.OnObterBairro(this.planoPesquisa, this.cidadeSelecionado).subscribe((response: Bairro[]) => {
      this.bairros = response;
    });
  }

  onSubmit() {
    // 'TODOS' só existe para o ng-select; o backend filtra apenas BGM e CGM.
    const categoria = this.produtoSelecionado === 'BGM' || this.produtoSelecionado === 'CGM'
      ? this.produtoSelecionado
      : null;

    this.redeCredenciadaService.OnObterRedeCredenciada(this.planoPesquisa, this.cidadeSelecionado, this.bairroSelecionado, categoria).subscribe((response: RedeCredenciada[]) => {
      this.redeCredenciadaArray = response;
    });
  }

  /** "BGM,CGM" vira "BGM · CGM" para o badge do card. */
  formatarProdutos(productCategories: string): string {
    return (productCategories || '').split(',').filter(p => p).join(' · ');
  }

  limpar() {
    this.estadoSelecionado = null;
    this.cidadeSelecionado = null;
    this.bairroSelecionado = null;
    this.produtoSelecionado = null;
    this.redeCredenciadaArray = [];
  }
}
